import type { BigNumber } from 'ethers';
import type { CryptoCossacks2022 as CCBaseContract } from '@crypto-cossacks/token/typechain';

// Get cossack name
export const getNickName = (
  contract: CCBaseContract,
  tokenId: number | string | BigNumber
): Promise<string> => contract.getNickName(tokenId);
